module.exports = __webpack_public_path__ + "static/blair-itc-bold-a0c79c3edcd4ec48ab1c425b9bb1b40e.woff2";